var _defs, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLpgo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 409.18 168.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#00aad4;}.cls-1,.cls-3{font-family:Elephant-Regular, Elephant;font-size:72px;letter-spacing:.05em;}.cls-1,.cls-3,.cls-4{isolation:isolate;}.cls-5,.cls-3{fill:red;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text3336",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 113.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BE")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(133.93 113.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " PACK")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3385-8",
    className: "cls-5",
    d: "M152.72,168.9l-12.33-.69,.05-167.53,12.33,.69-.05,167.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path5622",
    className: "cls-5",
    d: "M152.72,168.9l-12.33-.69,.05-167.53,12.33,.69-.05,167.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path5622-0",
    className: "cls-2",
    d: "M140.37,168.22l-12.33-.69,.05-167.53,12.33,.69-.05,167.53Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpgo);
export default __webpack_public_path__ + "static/media/lpgo.cf4ffefddacdbf111357d8288ecea6c8.svg";
export { ForwardRef as ReactComponent };